module.exports = __webpack_public_path__ + "static/media/2-circle-available.997d2161.svg";